// Interfaces compartidas para el hook useTransactionSearchParams

export interface TransactionFilters {
  status: string;
  payment_method_id: string;
  country: string;
  currency: string;
  from: string;
  to: string;
  search_by: string;
  transaction_id: string;
  external_id: string;
  client_name: string;
  client_email: string;
  tx_email: string;
  document: string;
  total_amount: string;
}

export interface PaginationState {
  page: number;
  per_page: number;
}

export interface SearchState {
  filters: TransactionFilters;
  pagination: PaginationState;
}

export interface UseTransactionSearchParamsReturn {
  searchState: SearchState;
  setFilters: (filters: Partial<TransactionFilters>) => void;
  setPage: (page: number) => void;
  setPerPage: (perPage: number) => void;
  clearFilters: () => void;
  hasActiveFilters: boolean;
}

// Valores por defecto

export const DEFAULT_FILTERS: TransactionFilters = {
  status: '',
  payment_method_id: '',
  country: '',
  currency: '',
  from: '',
  to: '',
  search_by: '',
  transaction_id: '',
  external_id: '',
  client_name: '',
  client_email: '',
  tx_email: '',
  document: '',
  total_amount: '',
};

export const DEFAULT_PAGINATION: PaginationState = {
  page: 1,
  per_page: 20,
};

// Constantes de validación

export const VALID_STATUSES = [
  'COMPLETED',
  'PENDING',
  'DECLINED',
  'CANCELLED',
  'REFUNDED',
] as const;

export type ValidStatus = (typeof VALID_STATUSES)[number];

/** Formato esperado para fechas: YYYY-MM-DD */
export const DATE_FORMAT_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/** Rango válido para page: entero >= 1 */
export const PAGE_MIN = 1;

/** Rango válido para per_page: entero entre 1 y 100 */
export const PER_PAGE_MIN = 1;
export const PER_PAGE_MAX = 100;
